const cachedAppLoadHashValue = '#cachedAppLoad';

export const addCachedAppLoadHashToUrl = (url: string): string => url.split('#')[0] + cachedAppLoadHashValue;
export const removeCachedAppLoadHashFromUrl = (url: string): string => url.split('#')[0];
export const isCachedAppPageLoadUrlHashPresent = (): boolean => location.hash === cachedAppLoadHashValue;
